// Small pill button that flips meta.mode between freeform and retro.
// Host-only — when meta.mode === 'retro' the rest of the retro chrome
// (PhaseBar, TimerWidget, vote pill) mounts. Lives in the StatusBar
// area next to HostPill.

import type * as Y from 'yjs';
import { Workflow } from 'lucide-react';
import type { BoardMode } from '@frame/shared';
import { setMode } from '../binding/metaMap';

interface Props {
  doc: Y.Doc;
  mode: BoardMode;
  isHost: boolean;
}

export function ModeToggle({ doc, mode, isHost }: Props) {
  if (!isHost) return null;
  const isRetro = mode === 'retro';
  return (
    <button
      type="button"
      onClick={() => setMode(doc, isRetro ? 'freeform' : 'retro')}
      aria-pressed={isRetro}
      title={isRetro ? 'Exit retro mode' : 'Start retro session'}
      className={[
        'h-7 px-2.5 inline-flex items-center gap-1.5 rounded-2',
        'text-12 font-medium',
        'transition-colors duration-micro ease-out',
        'focus-visible:outline-none focus-visible:shadow-focus',
        isRetro
          ? 'bg-accent text-accent-fg hover:bg-accent-hover'
          : 'bg-bg-panel border border-border-default text-fg-secondary hover:bg-bg-hover hover:text-fg-primary',
      ].join(' ')}
    >
      <Workflow size={13} strokeWidth={1.75} />
      {isRetro ? 'Retro' : 'Retro mode'}
    </button>
  );
}
